import { useContext, useRef, useState } from "react";
import classnames from "classnames";
import { useOnClickOutside } from "../../customHooks/useOnClickOutside";
import HeaderMultiSelect from "./HeaderMultiSelect";
import HeaderTextFilter from "./HeaderTextFilter";
import { useTranslation } from "react-i18next";
import TranslationContext from "../../providers/TranslationContext";

interface Props {
  col: any;
  onSort: any;
  onTextFilter: any;
  onMultiSelectFilterChange: any;
  onCancelFilter: any;
  currSortCol?: any;
}

const DataGridHeaderItem = (props: Props) => {
  const translationContext = useContext(TranslationContext) as any;
  const prefix = translationContext.prefix;
  const { t } = useTranslation();
  const [col, setCol] = useState(props.col);

  const onSort = (a: any) => {
    if (col.sortable) {
      let direction = col.direction !== undefined ? col.direction : false;
      const newCol = { ...props.col, direction: !direction };
      setCol(newCol);
      props.onSort(newCol);
    }
  };

  const handleMultiSelectFilterChange = (selectedFilters: any) => {
    props.onMultiSelectFilterChange({ col, selectedFilters });
  };

  const handleTextFilterChange = (filterBy: any) => {
    props.onTextFilter({ col, filterBy });
  };

  const handleTextFilterCancel = () => {
    props.onCancelFilter();
  };

  let direction = undefined;
  if (props.currSortCol && props.currSortCol.dataField == col.dataField) {
    direction = col.direction;
  }

  const css = classnames(
    "col",
    `dataFieldHeader_${col.dataField}`,
    col.sortable ? "sortable" : "",
    direction !== undefined ? (col.direction ? "asc" : "desc") : ""
  );

  const translationName = `${prefix}.Fields.${col.dataField}`;
  let name = t(translationName) ?? col.name;
  if (name === translationName) {
    name = col.name;
  }

  return (
    <th scope="col" className={css}>
      <div className="col-filter-name" onClick={onSort}>
        {name}
      </div>
      {col.filterable && col.filterType === "text" && (
        <HeaderTextFilter
          onTextFilter={handleTextFilterChange}
          onCancelFilter={handleTextFilterCancel}
        />
      )}

      {col.filterable && col.filterType === "dropdown" && (
        <div>
          {/* <i className="fas fa-filter"></i> */}
          <HeaderMultiSelect
            options={col.filters}
            onChange={handleMultiSelectFilterChange}
          />
        </div>
      )}
    </th>
  );
};

export default DataGridHeaderItem;
